<!-- components/Comunes/AsiFuncionaLubricantes.vue -->
<template>
  <section class="w-full bg-white">
    <!-- =========================
      BLOQUE 1: PASOS
    ========================== -->
    <div class="mx-auto w-full max-w-[1200px] px-4 md:px-6 pt-10 md:pt-12 pb-10 md:pb-12">
      <!-- TÍTULO (mobile en 2 líneas, desktop en 1) -->
      <h2 class="text-center font-extrabold uppercase tracking-wide text-ROJO_LEON leading-tight">
        <span class="">¿CÓMO FUNCIONA NUESTRO SERVICIO DE LUBRICANTES?</span>
      </h2>

      <!-- ===== DESKTOP: 3 cards + 2 flechas (→) ===== -->
      <div class="hidden md:flex items-start justify-center gap-10 mt-[70px]">
        <template v-for="(paso, index) in pasos" :key="paso.id">
          <!-- CARD PASO -->
          <div class="paso-wrap w-[340px]">
            <div class="relative">
              <!-- CÍRCULO ÍCONO -->
              <div class="paso-icon absolute left-1/2 -top-[65px] -translate-x-1/2">
                <div class="paso-icon-circle">
                  <!-- ÍCONO -->
                  <img
                    v-if="paso.icono === 'buscar'"
                    src="/img/aceites/busca.gif"
                    alt="Busca tu lubricante"
                    class="paso-gif"
                  />

                  <img
                    v-else-if="paso.icono === 'ubicacion'"
                    src="/img/aceites/indica_tu_ubicacion.gif"
                    alt="Indica tu ubicación"
                    class="paso-gif"
                  />

                  <img
                    v-else
                    src="/img/aceites/agenda_facilmente.gif"
                    alt="Agenda fácilmente"
                    class="paso-gif"
                  />
                </div>
              </div>

              <!-- CAJA -->
              <div class="paso-card pt-16 pb-8 px-10 text-center">
                <p class="paso-titulo">{{ paso.titulo }}</p>

                <p class="paso-texto">
                  <template v-for="(seg, i) in paso.descripcion" :key="i">
                    <strong v-if="seg.strong">{{ seg.texto }}</strong>
                    <span v-else>{{ seg.texto }}</span>
                  </template>
                </p>
              </div>
            </div>
          </div>

          <!-- FLECHA (→) ENTRE CARDS -->
          <div v-if="index < pasos.length - 1" class="flex items-center justify-center pt-10">
            <div class="flecha-circle">
              <svg viewBox="0 0 24 24" class="flecha-svg" aria-hidden="true">
                <path d="M9 6l6 6-6 6" fill="none" stroke="white" stroke-width="2.6" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
            </div>
          </div>
        </template>
      </div>

      <!-- ===== MOBILE: columna + flechas (↓) ===== -->
      <div class="md:hidden mt-[60px] flex flex-col items-center">
        <template v-for="(paso, index) in pasos" :key="paso.id">
          <div class="w-[92%] max-w-[420px]">
            <div class="relative">
              <!-- CÍRCULO ÍCONO -->
              <div class="absolute left-1/2 -top-[50px] -translate-x-1/2">
                <div class="paso-icon-circle paso-icon-circle--mobile">
                  <!-- ÍCONO -->
                  <img
                    v-if="paso.icono === 'buscar'"
                    src="/img/aceites/busca.gif"
                    alt="Busca tu lubricante"
                    class="paso-gif"
                  />

                  <img
                    v-else-if="paso.icono === 'ubicacion'"
                    src="/img/aceites/indica_tu_ubicacion.gif"
                    alt="Indica tu ubicación"
                    class="paso-gif"
                  />

                  <img
                    v-else
                    src="/img/aceites/agenda_facilmente.gif"
                    alt="Agenda fácilmente"
                    class="paso-gif"
                  />
                </div>
              </div>

              <!-- CAJA -->
              <div class="paso-card pt-14 pb-7 px-7 text-center">
                <p class="paso-titulo">{{ paso.titulo }}</p>

                <p class="paso-texto">
                  <template v-for="(seg, i) in paso.descripcion" :key="i">
                    <strong v-if="seg.strong">{{ seg.texto }}</strong>
                    <span v-else>{{ seg.texto }}</span>
                  </template>
                </p>
              </div>
            </div>
          </div>

          <!-- FLECHA (↓) ENTRE PASOS -->
          <div v-if="index < pasos.length - 1" class="my-6 mb-[65px] flex items-center justify-center">
            <div class="flecha-circle flecha-circle--mobile">
              <svg viewBox="0 0 24 24" class="flecha-svg" aria-hidden="true">
                <path d="M6 9l6 6 6-6" fill="none" stroke="white" stroke-width="2.6" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
            </div>
          </div>
        </template>
      </div>
    </div>

    <!-- =========================
      BLOQUE 2: INCLUYE
    ========================== -->
    <div class="w-full bg-white pb-12 md:pb-14">
      <div class="mx-auto w-full max-w-[1200px] px-4 md:px-6">
        <div class="incluye-wrap flex flex-col gap-8">
          <h3 class="incluye-titulo">
            Cada servicio de cambio de aceite en <span class="uppercase">LEÓN</span> incluye:
          </h3>

          <div class="grid grid-cols-1 md:grid-cols-2 justify-items-center gap-6 md:gap-0">
            <div v-for="item in incluye" :key="item.id" class="incluye-card w-full md:w-[70%]">
              <div class="flex items-start gap-5">
                <!-- ÍCONO -->
                <div class="shrink-0">
                  <img
                    v-if="item.icono === 'lubricante'"
                    src="/img/aceites/aceite_premium.svg"
                    alt="Aceite premium"
                    class="incluye-icono"
                  />

                  <img
                    v-else-if="item.icono === 'filtro'"
                    src="/img/aceites/filtro_aceite.svg"
                    alt="Filtro de aceite"
                    class="incluye-icono"
                  />

                  <img
                    v-else
                    src="/img/aceites/revision_seguridad.svg"
                    alt="Revisión de seguridad"
                    class="incluye-icono"
                  />                  
                </div>

                <!-- TEXTO -->
                <div class="min-w-0">
                  <p class="incluye-card-titulo">{{ item.titulo }}</p>
                  <p class="incluye-card-texto">{{ item.descripcion }}</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script setup>
const pasos = [
  {
    id: 'paso-1',
    icono: 'buscar',
    titulo: '1.Busca tu lubricante',
    descripcion: [
      { texto: 'Ingresa tu marca, año, modelo. Si sabes la viscosidad de tu aceite ', strong: false },
      { texto: '¡es mucho más fácil!', strong: true },
    ],
  },
  {
    id: 'paso-2',
    icono: 'ubicacion',
    titulo: '2.Indica tu ubicación',
    descripcion: [
      { texto: 'Te mostraremos el local ', strong: false },
      { texto: 'LEÓN', strong: true },
      { texto: ' más cercano para realizar el servicio.', strong: false },
    ],
  },
  {
    id: 'paso-3',
    icono: 'agenda',
    titulo: '3. Agenda fácilmente.',
    descripcion: [
      { texto: 'Elige día, hora y paga directamente en el local.', strong: false },
    ],
  },
]

const incluye = [
  {
    id: 'incluye-1',
    icono: 'lubricante',
    titulo: 'Aceite premium',
    descripcion: 'Trabajamos con marcas reconocidas a nivel mundial. (La cantidad de litros puede variar según el vehículo).',
  },
  {
    id: 'incluye-2',
    icono: 'filtro',
    titulo: '1 filtro de aceite (hasta $4.500)',
    descripcion: 'Incluimos gratis el filtro de aceite estándar en cada servicio. (No aplica para filtros especiales).',
  },
  /*
  {
    id: 'incluye-3',
    icono: 'revision',
    titulo: 'Revisión de seguridad GRATIS',
    descripcion: 'Al realizar tu cambio de aceite, revisamos 13 puntos de seguridad de tu auto sin costo adicional.',
  },
  */
]
</script>

<style scoped>
/* =========================
  Tipografía base del mock
========================= */
h2 {
  font-size: 22px;
}
@media (min-width: 768px) {
  h2 {
    font-size: 32px;
  }
}

/* =========================
  PASOS (cards)
========================= */
.paso-card {
  background: var(--GRIS_CLARO);             /* exacto del mock */
  border-radius: 14px;
  border: 1px solid #EBEBEB;
}

.paso-titulo {
  color: var(--ROJO_LEON);                   /* rojo mock */
  font-weight: 800;
  font-size: 18px;
  line-height: 1.2;
}

.paso-texto {
  margin-top: 12px;
  color: var(--GRIS_LEON);
  font-size: 18px;
  line-height: 1.6;
}

.paso-icon-circle {
  width: 120px;
  height: 120px;
  border-radius: 9999px;
  background: var(--BLANCO_LEON);
  border: 1px solid #EBEBEB;        /* aro sutil */
  display: flex;
  align-items: center;
  justify-content: center;
}

.paso-icon-circle--mobile {
  width: 100px;
  height: 100px;
}

.paso-svg {
  width: 62px;
  height: 62px;
}

@media (max-width: 767px) {
  .paso-titulo {
    font-size: 17px;
  }
  .paso-texto {
    font-size: 16px;
  }
  .paso-svg {
    width: 54px;
    height: 54px;
  }
}

/* =========================
  FLECHAS (círculo rojo + flecha blanca)
========================= */
.flecha-circle {
  width: 44px;
  height: 44px;
  border-radius: 9999px;
  background: var(--ROJO_LEON);
  display: flex;
  align-items: center;
  justify-content: center;
}

.flecha-circle--mobile {
  width: 40px;
  height: 40px;
}

.flecha-svg {
  width: 22px;
  height: 22px;
  display: block;
}

/* =========================
  INCLUYE (contenedor grande + cards)
========================= */
.incluye-wrap {
  background: var(--GRIS_CLARO);             /* exacto del mock */
  border-radius: 30px;
  padding: 44px 48px;
}

@media (max-width: 767px) {
  .incluye-wrap {
    padding: 34px 18px;
    border-radius: 28px;
  }
}

.incluye-titulo {
  text-align: center;
  color: var(--ROJO_LEON);
  font-weight: 800;
  font-size: 26px;
  line-height: 1.25;
}

@media (max-width: 767px) {
  .incluye-titulo {
    font-size: 22px;
  }
}

.incluye-card {
  background: var(--BLANCO_LEON);
  border-radius: 14px;
  padding: 22px 22px;
  box-shadow: 0 10px 20px rgba(0,0,0,0.07);  /* sombra suave mock */
}

.incluye-svg {
  width: 64px;
  height: 64px;
  display: block;
}

.incluye-icono {
  width: 64px;
  height: 64px;
  object-fit: contain;
  display: block;
}

.incluye-card-titulo {
  color: var(--ROJO_LEON);
  font-weight: 800;
  font-size: 16px;
  line-height: 1.2;
}

.incluye-card-texto {
  margin-top: 8px;
  color: var(--GRIS_LEON);
  font-size: 15px;
  line-height: 1.55;
}

.paso-gif {
  max-width: 80px;
  max-height: 80px;
  object-fit: contain;
  display: block;
}

@media (max-width: 767px) {
  .paso-gif {
    max-width: 80px;
    max-height: 80px;
  }
}

/* Mobile */
@media (max-width: 767px) {
  .incluye-icono {
    width: 56px;
    height: 56px;
  }
}
</style>
